import { useTranslation } from 'next-i18next';

import ArchiveField from '@/modules/settings/property/components/Fields/shared/ArchiveField';
import { Typography } from '@/shared/components/atoms';
import TooltipLite from '@/shared/components/atoms/TooltipLite';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Archive from '~/images/shared/Archive.svg';
import HorizontalHollowDots from '~/images/shared/HorizontalHollowDots.svg';

const ArchiveButton: React.FC<{
  fieldId: number;
  propertyId?: number;
  onArchive?: () => void;
}> = ({ fieldId, propertyId, onArchive }) => {
  const { t } = useTranslation();

  const { openModal } = useModal();

  const [selectedAsset] = useStore((store) => store?.asset);

  const entityId = selectedAsset?.id || propertyId;

  return entityId ? (
    <TooltipLite
      id={fieldId}
      eventToggle='onClick'
      content={
        <div
          className='flex cursor-pointer items-center gap-8 px-8 py-8 text-error-400'
          onClick={() => {
            openModal(
              <ArchiveField
                onArchive={onArchive}
                fieldId={fieldId}
                entityId={entityId}
              />
            );
          }}
        >
          <Archive width='24' height='24' />
          <Typography variant='subtitle2'>{t('Archive')}</Typography>
        </div>
      }
    >
      <span className='cursor-pointer text-primary-default'>
        <HorizontalHollowDots width='24' height='24' />
      </span>
    </TooltipLite>
  ) : null;
};

export default ArchiveButton;
